import axios from './../api'

const repairApply = (data) => {
  return axios({
    url: `/api/repair/apply`,
    method: 'post',
    data,
  })
}
const repairTranslation = (data) => {
  return axios({
    url: `/api/repair`,
    method: 'post',
    data,
  })
}
const repairEditTranslation = (data) => {
  return axios({
    url: `/api/repair`,
    method: 'put',
    data,
  })
}
const accidentList = (params) => {
  return axios({
    url: `/api/accident/list`,
    params,
  })
}

const maintainApply = (data) => {
  return axios({
    url: `/api/maintain/apply`,
    method: 'post',
    data,
  })
}

const motApply = (data) => {
  return axios({
    url: `/api/mot/apply`,
    method: 'post',
    data,
  })
}

const insureApply = (data) => {
  return axios({
    url: `/api/insure/apply`,
    method: 'post',
    data,
  })
}

const accidentApply = (data) => {
  return axios({
    url: `/api/accident/apply`,
    method: 'post',
    data,
  })
}

const feeApply = (data) => {
  return axios({
    url: `/api/fee/apply`,
    method: 'post',
    data,
  })
}

const workOrderAdd = (data) => {
  return axios({
    url: `/api/workOrder/add`,
    method: 'post',
    data,
  })
}
const workOrderList = (params) => {
  return axios({
    url: `/api/workOrder/page`,
    params,
  })
}

const workOrderCancel = (params) => {
  return axios({
    url: `/api/workOrder/cancel`,
    params,
  })
}

export default {
  repairApply,
  accidentList,
  maintainApply,
  motApply,
  insureApply,
  accidentApply,
  repairTranslation,
  repairEditTranslation,
  feeApply,
  workOrderAdd,
  workOrderList,
  workOrderCancel
}
